



































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { ListOption } from '@/interfaces/registration/ListOption';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import RequiredFieldValidator from './validation/RequiredFieldValidator.vue';
import lodash from 'lodash';

  @Component({
    components: { RequiredFieldValidator }
  })
export default class FormSelect extends Mixins(FormFieldMixin) {
    @Prop() readonly listOptions!: Array<ListOption>;
    @Prop() readonly value!: string;

    openDropdown = false;
    selectedIndex = -1;

    public selectedText (optionValue: string): string | undefined {
      const option = lodash.find(this.listOptions, { value: optionValue.toString() });
      return option?.text;
    }

    public hasValue (): boolean {
      return this.value !== undefined && this.value !== null && this.value !== '';
    }

    mounted () {
      document.addEventListener('click', this.onBlur);
      const dropdownMenu = this.$refs.dropdownMenu as HTMLElement;
      dropdownMenu.addEventListener('keydown', this.onKeyDown);
    }

    beforeDestroy () {
      document.removeEventListener('click', this.onBlur);
      const dropdownMenu = this.$refs.dropdownMenu as HTMLElement;
      dropdownMenu.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown (event: KeyboardEvent) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.openDropdown = true;
        this.navigateOptions(1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.openDropdown = true;
        this.navigateOptions(-1);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        this.openDropdown = false;
      }
    }

    onBlur (event: MouseEvent) {
      const dropdownMenu = this.$refs.dropdownMenu as HTMLElement;
      const target = event.target as HTMLElement;
      if (!dropdownMenu.contains(target)) {
        this.openDropdown = false;
      }
    }

    navigateOptions (direction: number) {
      const newIndex = this.selectedIndex + direction;
      if (newIndex >= -1 && newIndex < this.listOptions.length) {
        this.selectedIndex = newIndex;
        this.selectOption(this.selectedIndex, false);
        this.scrollToOption(newIndex);
      }
    }

    scrollToOption (index: number) {
      const dropdownMenuList = this.$refs.dropdownMenuList as HTMLElement;
      const selectedOption = dropdownMenuList.children[index + 1] as HTMLElement;
      if (selectedOption) {
        const dropdownMenuRect = dropdownMenuList.getBoundingClientRect();
        const selectedOptionRect = selectedOption.getBoundingClientRect();
        const distanceToTop = selectedOptionRect.top - dropdownMenuRect.top;
        const distanceToBottom = selectedOptionRect.bottom - dropdownMenuRect.bottom;
        if (distanceToTop < 0) {
          dropdownMenuList.scrollTop += distanceToTop;
        } else if (distanceToBottom > 0) {
          dropdownMenuList.scrollTop += distanceToBottom;
        }
      }
    }

    selectOption (index: number, close: boolean) {
      this.selectedIndex = index;

      index === -1
        ? this.$emit('input', undefined)
        : this.$emit('input', this.listOptions[this.selectedIndex].value);

      if (close) {
        this.openDropdown = false;
      }
    }
}
